import { render, staticRenderFns } from "./dealsOverviewScreen.vue?vue&type=template&id=18277994&lang=pug"
import script from "./dealsOverviewScreen.vue?vue&type=script&lang=js"
export * from "./dealsOverviewScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports